import axios from 'axios'

/**
 * Fetch alarms grouped by date, company and site
 * @param page Page number
 * @param limit Number of dates per page
 * @param startDate Start date filter (optional)
 * @param endDate End date filter (optional)
 * @param siteAcknowledge Filter by site acknowledge status (optional)
 * @param companyId Filter by company ID (optional)
 * @returns Grouped alarms data
 */
export const getGroupedAlarms = async (
  page: number = 1,
  limit: number = 10,
  startDate?: Date,
  endDate?: Date,
  siteAcknowledge?: boolean,
  companyId?: number,
  alertType?: 'hourly' | 'daily'
) => {
  try {
    let url = `/alarms/grouped?page=${page}&limit=${limit}`

    if (startDate) {
      const formattedStartDate = startDate.toISOString().split('T')[0] // Format as YYYY-MM-DD
      url += `&start_date=${formattedStartDate}`
    }

    if (endDate) {
      const formattedEndDate = endDate.toISOString().split('T')[0] // Format as YYYY-MM-DD
      url += `&end_date=${formattedEndDate}`
    }

    if (siteAcknowledge !== undefined) {
      url += `&site_acknowledge=${siteAcknowledge}`
    }

    if (companyId !== undefined && companyId !== null) {
      url += `&company_id=${companyId}`
    }

    if (alertType !== undefined && alertType !== null) {
      url += `&alert_type=${alertType}`
    }

    const response = await axios.get(url)
    return response.data.data
  } catch (error) {
    console.error('Error fetching grouped alarms:', error)
    throw error
  }
}

export const getAlertType = async (companyId: number) => {
  const response = await axios.get(`/company/getAlertType/${companyId}`)
  return response.data.data
}
